import { ButtonBox, ButtonWrap } from "@shared/src";
import styles from "./secretLoungeModal.module.scss";
import * as React from "react";
import { v4 as uuidv4 } from "uuid";

interface IModalButton {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  theme?: string;
  size?: string;
  action: () => void;
}
interface IModal {
  modalId?: string;
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  overlay?: boolean;
  overlayValue?: number;
  overlayStyle?: React.CSSProperties;
  modalPointText?: string;
  modalBoldText?: string;
  modalText?: string;
  buttons?: IModalButton[];
}
const SecretLoungeModal = ({
  modalId,
  isShow,
  setIsShow,
  overlay = false,
  overlayValue = 0.08,
  overlayStyle,
  modalPointText = "",
  modalBoldText = "",
  modalText = "",
  buttons,
}: IModal) => {
  const uuid = uuidv4();
  return (
    <div className={styles["modal-wrap"]} style={{ display: isShow ? "block" : "none" }}>
      {overlay && (
        <div
          className={styles["modal-overlay"]}
          style={{
            backgroundColor: `rgba(0, 0, 0, ${overlayValue})`,
            ...overlayStyle,
          }}
          onClick={() => setIsShow(false)}
        ></div>
      )}
      <div className={styles["modal"]}>
        <div className={`${styles["modal-content-box"]}`}>
          {modalPointText && <p className={styles["modal-point-text"]}>{modalPointText}</p>}
          {modalBoldText && <p className={styles["modal-bold-text"]}>{modalBoldText}</p>}
          {modalText && <p className={styles["modal-text"]}>{modalText}</p>}
        </div>

        {buttons && (
          <ButtonWrap
            firstRatio={buttons.length >= 2 ? 1 : null}
            noPaddingPosition="all"
            className={`${styles["modal-btn-wrap"]}`}
          >
            {buttons.map((button) => (
              <ButtonBox
                key={`${modalId ? modalId : uuid}-${button.name}`}
                text={button.name}
                style={button.style ? button.style : {}}
                size={button.size ? button.size : "giant"}
                theme={button.theme ? button.theme : "red500"}
                fullWidth={buttons.length === 1}
                className={`${button?.className ? button.className : ""}`}
                onClick={() => button.action()}
              />
            ))}
          </ButtonWrap>
        )}
      </div>
    </div>
  );
};

export default SecretLoungeModal;
